import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { AnyoGridComponent } from 'projects/app-core/src/app/models/AnyoGridComponent';
import { ForumRegistrationDateFilter, ForumRegistrationFilter, ForumRegistrationGridRequest, ForumRegistrationSearch, ForumRegistrationSort } from '../../../models/events/forumsRegistrationsGridRequest';
import { ForumsRegistrationsAdminResponse, ForumsRegistrationsGridFilterOptions } from '../../../models/events/forumRegistrationsGridResponse';
import { AnyoForum } from '../../../models/events/AnyoForums';
import { EventsService } from '../../../services/events.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GridResponse } from 'projects/app-core/src/models/gridResponse';
import { Observable } from 'rxjs';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import * as moment from 'moment';
import { AnyoSortDirection } from 'projects/app-core/src/models/gridRequest';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import {
  AddForumRegistrationCSVRequest,
  AdminForumRegistrationRequestCSVData,
  AdminForumRegistrationResponse,
  ForumRegistrationErrorRow,
  ForumRegistrationErrorRowValidation,
} from '../../../models/events/AddForumRegistrationRequest';

@Component({
  selector: 'app-manage-forum-registrations',
  templateUrl: './manage-forum-registrations.component.html',
  styleUrl: './manage-forum-registrations.component.scss'
})
export class ManageForumRegistrationsComponent extends AnyoGridComponent<
  ForumRegistrationSort,
  ForumRegistrationFilter,
  ForumRegistrationSearch,
  ForumRegistrationDateFilter,
  ForumRegistrationGridRequest,
  ForumsRegistrationsGridFilterOptions,
  ForumsRegistrationsAdminResponse
> {
  forumId = ''
  forum: AnyoForum | undefined = undefined
  globalSearchInput = '';
  forumRegistrationsLoading = false
  forumLoading = false;
  currentFilters: {
    FORUM_ID: string[];
    PAYMENT_TYPE: string[];
    HIDE_TEST_REGISTRATION: string[];
  } = {
      FORUM_ID: [],
      PAYMENT_TYPE: [],
      HIDE_TEST_REGISTRATION: ["false"]
    };

  currentDateFilters?: Record<
    ForumRegistrationDateFilter,
    { from: Date; to: Date } | undefined
  >;
  currentSort?: Partial<Record<ForumRegistrationSort, AnyoSortDirection>>;

  emailColumnSearch = ""
  selectedRegistrationMode: string | null = null;
  isRegistrationModeMenu = false;

  paymentTypeCheckBoxOptions: { label: string; value: string; checked: boolean; }[] = [];

  forumsRegistrationColumnFilterDate: Date[] | undefined;
  dateFormat = 'dd/MM/yyyy';

  showTestForums: boolean = false;

  isCsvModalVisible = false;
  csvHeaders: string[] = [];
  isRegistrationResultModalVisible = false;
  registrationResult: AdminForumRegistrationResponse | undefined;
  isCsvValidationModalVisible = false;
  invalidCsvRows: ForumRegistrationErrorRowValidation[] = [];
  selectedCsvFile: File | null = null;
  selectedCsvData: AdminForumRegistrationRequestCSVData[] = [];
  csvLoading: boolean = false;

  downloadSampleTemplate(): void {
    const sampleData: Record<string, string>[] = [
      {
        'Email (Required)': 'jane.doe@example.com',
        'First Name (Optional)': 'Jane',
        'Last Name (Optional)': 'Doe',
        'Registered From (Optional)': 'Admin',
        'Registered Time (Optional)': moment().format('DD-MM-YYYY HH:mm:ss'),
        'Registration Approval Status (Optional)': 'Approved',
      },
    ];
    const csvConfig = mkConfig({
      useKeysAsHeaders: true,
      filename: `forum_registration_sample_template_${moment().format('DD-MM-yyyy_HH-mm-ss')}`,
    });
    const csv = generateCsv(csvConfig)(sampleData);
    download(csvConfig)(csv);
  }

  constructor(
    private eventService: EventsService,
    auth: AuthService,
    router: Router,
    route: ActivatedRoute,
    private toastService: ToastService,
    public utils: UtilsService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {
    super(auth, router, route)
  }


  private fetchForum(): void {
    this.forumLoading = true
    this.eventService.getForum(this.forumId).subscribe({
      next: (forum) => {
        this.forum = forum;
        this.forumLoading = false;
      },
      error: (error) => {
        this.forumLoading = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);

      }
    });
  }

  override async ready(): Promise<void> {
    const forumId = this.route.snapshot.queryParamMap.get('forumId');

    if (!forumId) {
      return;
    }
    this.forumId = forumId;
    this.currentFilters.FORUM_ID = [forumId];
    this.fetchForum();
    super.ready();

    // this.route.queryParamMap.subscribe(params => {
    //   this.forumId = params.get('forumId') || '';
    //   if (this.forumId) {
    //     this.fetchForum();
    //   }
    // });
  }

  protected override fetchGridData(request: ForumRegistrationGridRequest): Observable<GridResponse<ForumsRegistrationsGridFilterOptions | undefined, ForumsRegistrationsAdminResponse>> {
    return this.eventService.getForumRegistrations(request)
  }

  override fetch(): void {
    this.forumRegistrationsLoading = true
    const req = this.buildRequest(false)
    this.updateUrlWithQuery(req)

    this.fetchGridData(req).subscribe({
      next: (res) => {
        this.data = res.data;
        this.totalRecords = res.totalRecords
        this.pageSize = res.pageSize;
        this.forumRegistrationsLoading = false

        this.data.forEach((item) => {
          item.paymentTypeColor = this.utils.getRandomColor()
        })

        if (res.filterOptions) {
          this.paymentTypeCheckBoxOptions = [];
          res.filterOptions.forumPaymentTypes.forEach((data) => {
            this.paymentTypeCheckBoxOptions.push({
              checked: false,
              label: this.utils.convertToTitleCase(data),
              value: data
            })
          })
        }
      },
      error: () => {
        this.forumRegistrationsLoading = false
        this.toastService.showError('Error fetching forum registrations')
      }
    })
  }
  protected override buildRequest(exportFlag?: boolean): ForumRegistrationGridRequest {

    const filters = {
      ...this.currentFilters,
      ...(this.forumId ? { FORUM_ID: [this.forumId] } : {})
    };
    const req: ForumRegistrationGridRequest = {

      page: this.page,
      pageSize: this.pageSize,
      export: exportFlag,
      filters: filters,
      globalSearch: this.globalSearchInput.length ? [this.globalSearchInput.trim()] : [],
      from: undefined,
      to: undefined,
      sort: this.currentSort,
      dateFilters: this.currentDateFilters,
      searchQuery: this.emailColumnSearch ? { [ForumRegistrationSearch.USER_EMAIL]: this.emailColumnSearch } : undefined,
      tab: undefined
    } as ForumRegistrationGridRequest;
    return req
  }

  protected override applyRequestToState(req: ForumRegistrationGridRequest): void {
    super.applyRequestToState(req)
    if (req.filters) {
      this.currentFilters = {
        FORUM_ID: [this.forumId],
        PAYMENT_TYPE: req.filters.PAYMENT_TYPE ?? [],
        HIDE_TEST_REGISTRATION: req.filters.HIDE_TEST_REGISTRATION ?? ['false']
      }
    }
    if (req.filters?.HIDE_TEST_REGISTRATION) {
      this.showTestForums = req.filters.HIDE_TEST_REGISTRATION.includes('true')
    }

    if (req.dateFilters) {
      this.currentDateFilters = req.dateFilters
    }

    if (req.globalSearch && req.globalSearch.length) {
      this.globalSearchInput = req.globalSearch[0]
    }
    if (req.searchQuery?.USER_EMAIL) {
      this.emailColumnSearch = req.searchQuery.USER_EMAIL
    }
    if (req.sort) {
      this.currentSort = req.sort
    }
  }

  async testForumChangeFn(flag: boolean) {
    this.showTestForums = flag
    this.currentFilters.HIDE_TEST_REGISTRATION = flag ? ['true'] : ['false'];
    this.page = 1;
    this.fetch();
  }

  async paymentTypeFilter(paymentType: string[]) {
    this.currentFilters.PAYMENT_TYPE = paymentType && paymentType.length ? paymentType : [];
    this.page = 1;
    this.fetch();
  }

  async dateFilter() {
    if (
      this.forumsRegistrationColumnFilterDate &&
      this.forumsRegistrationColumnFilterDate.length
    ) {
      const startDate = moment(this.forumsRegistrationColumnFilterDate[0])
        .startOf('day')
        .toDate();
      const endDate = moment(this.forumsRegistrationColumnFilterDate[1])
        .endOf('day')
        .toDate();
      const isToday = moment(startDate).isSame(endDate, 'day');

      const dateFilters: Record<ForumRegistrationDateFilter,
        { from: Date; to: Date } | undefined
      > = {
        [ForumRegistrationDateFilter.REGISTRATION_DATE]: {
          from: isToday ? moment().startOf('day').toDate() : startDate,
          to: isToday ? moment(endDate).endOf('day').toDate() : endDate,
        },
      };

      this.currentDateFilters = dateFilters;
      this.page = 1;
      this.fetch();
    }
  }

  async sortRegisteredDates($event: string | null) {
    if ($event) {
      // Assuming you have ForumRegistrationSort.REGISTRATION_DATE
      this.currentSort = {
        [ForumRegistrationSort.REGISTRATION_DATE]:
          $event === 'ascend'
            ? AnyoSortDirection.ASC
            : AnyoSortDirection.DESC
      } as Record<ForumRegistrationSort, AnyoSortDirection>;
    } else {
      // Clear sort when $event is null
      this.currentSort = undefined;
    }
    this.page = 1;
    this.fetch();
  }


  async userEmailSearchFn() {
    this.emailColumnSearch = this.emailColumnSearch.trim();
    if (this.emailColumnSearch.length) {
      this.page = 1;
      this.fetch();
    }
  }

  async resetUserEmailSearch() {
    this.emailColumnSearch = '';
    this.page = 1;
    this.fetch();
  }

  async resetUserEmailFilter() {
    this.emailColumnSearch = '';
    this.globalSearchInput = '';
    this.page = 1;
    this.fetch();
  }

  getRegistrationModeFilter() {
    return this.selectedRegistrationMode ? [this.selectedRegistrationMode] : [];
  }

  async searchGlobal() {
    if (this.globalSearchInput.trim().length) {
      this.page = 1;
      this.fetch();
    }
  }
  async resetFilter() {
    this.globalSearchInput = '';
    this.emailColumnSearch = '';
    this.forumsRegistrationColumnFilterDate = undefined;

    this.currentFilters = {
      FORUM_ID: [],
      PAYMENT_TYPE: [],
      HIDE_TEST_REGISTRATION: [this.showTestForums ? 'true' : 'false']
    };

    this.currentDateFilters = undefined;
    this.page = 1;
    this.fetch();
  }

  async resetDateFilter() {
    this.forumsRegistrationColumnFilterDate = undefined;
    this.currentDateFilters = undefined;
    this.page = 1;
    this.fetch();
  }




  exportRegistrationTable() {
    this.forumRegistrationsLoading = true;
    const req = this.buildRequest(true);

    this.fetchGridData(req).subscribe({
      next: (response) => {
        try {
          const tableData = response.data.map((data) => {
            return {
              userName: data.userName,
              userEmail: data.userEmail,
              registeredOn: this.utils.convertEpochToFormattedDate(data.registerOn),
              amount: data.amount,
            };
          });

          const csvData = tableData as unknown as Record<
            string,
            string | null | undefined
          >[];
          const csvConfig = mkConfig({ useKeysAsHeaders: true });
          const csv = generateCsv(csvConfig)(csvData);
          download(csvConfig)(csv);
          this.forumRegistrationsLoading = false;
          this.toastService.showSuccess('Export successful');
        } catch (e) {
          this.toastService.showError('Export Error');
          this.forumRegistrationsLoading = false;
        }
      },
      error: (error) => {
        this.forumRegistrationsLoading = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      }
    });
  }

  onCsvFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        this.selectedCsvFile = file;
        const reader = new FileReader();

        reader.onload = () => {
          const text = reader.result as string;
          this.ngZone.run(() => {
            this.selectedCsvData = this.parseCsvToJson(text);
            this.csvHeaders = Object.keys(this.selectedCsvData[0] || {});
          });
        };

        reader.readAsText(file);
      } else {
        input.value = '';
        this.selectedCsvFile = null;
        this.selectedCsvData = [];
      }
    }
  }

  uploadCsv(): void {
    if (!this.selectedCsvData.length) return;
    const { validRows, invalidRows } = this.validateCsvData(
      this.selectedCsvData,
    );

    if (invalidRows.length) {
      this.invalidCsvRows = invalidRows;
      this.isCsvValidationModalVisible = true;
      return;
    }

    const req: AddForumRegistrationCSVRequest = {
      forumId: this.forumId,
      csvData: validRows,
    };
    this.csvLoading = true;
    this.eventService.addForumRegistration(req).subscribe({
      next: (response) => {
        this.selectedCsvFile = null;
        this.selectedCsvData = [];
        this.registrationResult = response;
        this.isRegistrationResultModalVisible = true;
        this.fetch();
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
      complete: () => {
        this.csvLoading = false;
      },
    });
  }

  private validateCsvData(data: AdminForumRegistrationRequestCSVData[]): {
    validRows: AdminForumRegistrationRequestCSVData[];
    invalidRows: ForumRegistrationErrorRowValidation[];
  } {
    const validRows: AdminForumRegistrationRequestCSVData[] = [];
    const invalidRows: ForumRegistrationErrorRowValidation[] = [];

    data.forEach((row, index) => {
      const issues: string[] = [];

      if (!row.email?.trim()) {
        issues.push('Email missing');
      } else if (!this.utils.validateEmail(row.email)) {
        issues.push('Invalid email format');
      }

      if (issues.length) {
        invalidRows.push({
          row: index + 2,
          email: row.email?.trim() || 'N/A',
          reason: issues.join(', '),
        });
        return;
      }

      validRows.push(row);
    });

    return { validRows, invalidRows };
  }

  registrationSuccessCount(): number {
    if (!this.registrationResult) return 0;
    return (
      this.registrationResult.total -
      this.registrationResult.failed.length -
      this.registrationResult.skipped.length
    );
  }

  exportRegistrationRows(
    rows: ForumRegistrationErrorRow[],
    label: 'failed' | 'skipped',
  ): void {
    if (!rows?.length) return;
    const csvData = rows as unknown as Record<
      string,
      string | null | undefined
    >[];
    const csvConfig = mkConfig({
      useKeysAsHeaders: true,
      filename: `forum_registration_${label}_${moment().format('DD-MM-yyyy_HH-mm-ss')}`,
    });
    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  }

  viewCsvData(): void {
    this.csvHeaders = this.selectedCsvData.length
      ? Object.keys(this.selectedCsvData[0])
      : [];
    this.isCsvModalVisible = true;
    this.cd.detectChanges();
  }

  parseCsvToJson(csvText: string): AdminForumRegistrationRequestCSVData[] {
    const lines = csvText
      .trim()
      .split('\n')
      .filter((line) => line.trim().length > 0);
    if (lines.length < 2) return [];

    const rawHeaders = this.parseCsvLine(lines[0]);
    this.csvHeaders = rawHeaders; // keep original for modal display

    // Prepare clean keys for object mapping
    const cleanHeaders = rawHeaders.map((h) =>
      h.toLowerCase().replace(/\s+/g, ''),
    );

    return lines
      .slice(1)
      .map((line) => {
        const values = this.parseCsvLine(line);
        const row: Record<string, string> = {};

        cleanHeaders.forEach((key, i) => {
          row[key] = values[i] ?? '';
        });

        return row as AdminForumRegistrationRequestCSVData;
      })
      .filter((row) => !this.isBlankCsvRow(row));
  }

  private isBlankCsvRow(row: Record<string, string>): boolean {
    return Object.values(row).every((value) => !/[a-zA-Z0-9]/.test(value));
  }

  parseCsvLine(line: string): string[] {
    const result: string[] = [];
    let current = '';
    let insideQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      const nextChar = line[i + 1];

      if (char === '"' && insideQuotes && nextChar === '"') {
        current += '"'; // Escaped quote
        i++; // skip next quote
      } else if (char === '"') {
        insideQuotes = !insideQuotes;
      } else if (char === ',' && !insideQuotes) {
        result.push(this.stripOuterQuotes(current.trim()));
        current = '';
      } else {
        current += char;
      }
    }

    result.push(this.stripOuterQuotes(current.trim())); // last field
    return result;
  }

  // Strip outer quotes if present
  stripOuterQuotes(str: string): string {
    if (str.startsWith('"') && str.endsWith('"')) {
      return str.slice(1, -1).replace(/""/g, '"');
    }
    return str;
  }
}
